import DrawingOfficeSettings from "./settings_index";
import DrawingOfficeDrawingTypesRoutes from "modules/drawing_office/drawing_types/web/routes";
import DrawingOfficeWorkPackageStatusesRoutes from "modules/drawing_office/work_package_statuses/web/routes";
import DrawingOfficePdfComparerRoutes from "modules/drawing_office/pdf_comparer/web/routes";
import DrawingOfficeIndex from "./index";

let routes = [
  {
    path: "/drawing_office/settings",
    name: "drawing_office_settings",
    component: DrawingOfficeSettings,
  },
];
routes = _.concat(
  routes,
  DrawingOfficePdfComparerRoutes,
  DrawingOfficeDrawingTypesRoutes,
  DrawingOfficeWorkPackageStatusesRoutes
);
routes.push({
  path: "/drawing_office",
  exact: true,
  name: "drawing_office",
  component: DrawingOfficeIndex,
});

export default routes;
